export default __webpack_public_path__ + "static/media/Licenses_BG-01.c7281e6b.png";